<template>
	<div class="header-top-box">

		<div class="header-top">
			<div class="w1200">
				<div class="h-t-left fl">欢迎来到北京建筑设施服务协会</div>
				<!--<div class="h-t-right fr">
					<a href="#" target="_blank">注册</a>
					<a href="#" target="_blank">登录</a>
				</div>-->
			</div>
		</div>
		<div class="header w1200 clearfix">
			<div class="logo fl">
				<a href="/"><img src="../assets/images/logo.png" width="446" height="70" /></a>
			</div>
			<!--<div class="searchbox fr">
				<input type="text" placeholder="请输入搜索内容" />
				<a href="javascript:;">搜索</a>
			</div>-->
		</div>
		<div class="nav">
			<div class="w1200">
				<ul>
					<li class="nav-item" v-for="(item, index) in nav" @click="routerLink(index, item.path)" :key="index">
						<!-- 判断高亮表 -->
						<a :class=" navIndex === index ? 'item-cn hover' : 'item-cn'">
							{{ item.title }}
						</a>


					</li>
				</ul>

			</div>
		</div>
	</div>
</template>

<script>
	export default {

		data() {
			return {
				
				nav: [{
						title: '首页',
						path: '/'
					},
					{
						title: '关于协会',
						path: '/IntroductionList'
					},
					{
						title: '协会通知',
						path: '/NoticeList'
					},
					{
						title: '团体标准',
						path: '/GroupList'
					},
					{
						title: '会员服务',
						path: '/MemberService' 
					},
					{
						title: '认证中心',
						path: '/Authentication'
					},
					{
						title: '联系我们',
						path: '/ContactUs'
					},

				],
				navIndex: 0,
			}
		},
		methods: {
			routerLink(index, path) {
				// 点击哪个路由就赋值给自定义的下下标
				this.navIndex = index;
				// 路由跳转
				this.$router.push(path)
			},

			/**
			 * 检索当前路径
			 * @param path
			 */
			checkRouterLocal(path) {
				// 查找当前路由下标高亮
				this.navIndex = this.nav.findIndex(item => item.path === path);
			}

		},
		watch: {
			"$route" () {
				// 获取当前路径
				let path = this.$route.path;
				// 检索当前路径
				this.checkRouterLocal(path);
			}
		},
		components: {}
	}
</script>

<style>
	@import "../assets/css/common.css";
</style>


// WEBPACK FOOTER //
// src/components/Header.vue